module.exports = __webpack_public_path__ + "img/bg8.a2f7be49.png";